import { styled } from "@mui/material/styles";

import { accessibleInteractiveColors } from "@/theme/accessibility";

export const CardStyled = styled("div")(({ theme }) => ({
  // "& .jobRole": {
  //   display: "flex",
  // },
  "& .monitoring": {
    borderRadius: "10px",
    height: "60px",
    background: "#EAF6FF",
    margin: "10px",
    padding: "0 0 0 10px",
    paddingBottom: "0 !important",
    display: "flex",
    alignItems: "center",
    fontFamily: "Poppins",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
  },
  "& .monitoring:hover": {
    // background: "#BFE3FF",
    // boxShadow: "0px 4px 4px 10px rgba(0, 0, 0, 0.25)",
  },

  "& .selected": {
    background: "#3e73a4",
    color: "#fff",
  },

  "& .Card": {
    margin: "10px ",
  },
  "& .LastWeekData": {
    padding: "12px",
    width: "100%",
    borderBottom: "1px solid #ccc ",
    fontSize: "20px",
    fontWeight: "500",
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    minWidth: 0,
    boxSizing: "border-box",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "Poppins",
    textTransform: "capitalize",
  },
  "& .JobCard": {
    width: "100% !important",
    marginBottom: "20px",
    marginTop: 0,
  },
  "& .CardData": {
    borderRadius: "15px",
    border: "1px solid #BFE3FFB8",
    fontFamily: "Poppins",
  },
  "& .data-view-card": {
    borderRadius: "8px",
    borderColor: "#DFE5EF",
    boxShadow: "0 1px 3px rgba(31, 73, 112, 0.08)",
    height: "auto !important",
    minHeight: "0 !important",
    overflow: "hidden",
  },
  "& .data-view-card > .MuiBox-root": {
    height: "auto !important",
    minHeight: "0 !important",
  },
  "& .data-view-card .LastWeekData": {
    height: "auto !important",
    minHeight: "68px",
    padding: "16px 24px",
    borderBottomColor: "#DFE5EF",
    gap: "16px",
    display: "flex !important",
    flexWrap: "wrap",
    alignItems: "center !important",
  },
  "& .data-view-card .data-view-card-actions, & .data-view-card .data-view-secondary-actions, & .data-view-card .data-view-primary-actions":
    {
      height: "auto !important",
      minHeight: "0 !important",
    },
  "& .data-view-card .data-view-card-actions": {
    width: "auto !important",
    flex: "0 1 auto",
  },
  "& .data-view-card .heading-title": {
    color: "#2A3547 !important",
    fontSize: "20px !important",
    fontWeight: "600 !important",
    letterSpacing: "normal !important",
    margin: "0 !important",
    flex: "0 1 auto !important",
    flexBasis: "auto !important",
    minWidth: "min(260px, 100%) !important",
  },
  "& .data-view-card .data-view-card-actions .btn": {
    minHeight: "36px",
    height: "36px",
    borderRadius: "6px",
    padding: "6px 12px",
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "18px",
    boxSizing: "border-box",
  },
  "& .data-view-card .data-view-secondary-actions > *:first-of-type .btn": {
    border: `1px solid ${accessibleInteractiveColors.actionBlue} !important`,
    background: "#FFFFFF !important",
    color: `${accessibleInteractiveColors.actionBlue} !important`,
    boxShadow: "none !important",
  },
  "& .data-view-card .data-view-secondary-actions > *:not(:first-of-type) .btn":
    {
      border: `1px solid ${accessibleInteractiveColors.actionBlue} !important`,
      background: `${accessibleInteractiveColors.actionBlue} !important`,
      color: "#FFFFFF !important",
      boxShadow: "0 1px 2px rgba(31, 73, 112, 0.16) !important",
    },
  "& .heading-title": {
    color: " var(--colors-green-900, #00261C) !important",
    fontFamily: "Poppins  !important",
    fontSize: "20px  !important",
    fontStyle: "normal  !important",
    fontWeight: "500  !important",
    lineHeight: "normal  !important",
    letterSpacing: "0.32px  !important",
    margin: "6px 10px 0px !important",
    whiteSpace: "normal",
    flex: "1 1 260px",
    minWidth: 0,
    maxWidth: "100%",
    overflow: "visible",
    overflowWrap: "anywhere",
    textOverflow: "clip",
  },
  "& .jobRole": {
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    "& .LastWeekData": {
      alignItems: "stretch",
    },
    "& .heading-title": {
      flexBasis: "100%",
    },
    "& .data-view-card .LastWeekData": {
      flexDirection: "column",
    },
    "& .data-view-card .data-view-card-actions": {
      width: "100% !important",
    },
  },
}));
